var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProcessLoop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 252.58685 213.87201",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.3782 -39.059)",
    fill: "none",
    strokeWidth: 0.52917
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 117.58,40.4 A 105.67,105.67 0 0 0 16.01,150.02 105.67,105.67 0 0 0 125.63,251.59 105.67,105.67 0 0 0 227.2,141.97 105.67,105.67 0 0 0 117.58,40.4 Z",
    strokeDashoffset: 100
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57.256 119.89-41.006 18.631-20.398-35.968m250.13 101.63-21.375-35.524-40.518 18.409"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessLoop);
export default __webpack_public_path__ + "static/media/processLoop.e28e9795d2b8d89b76e19a6d63d3373a.svg";
export { ForwardRef as ReactComponent };